import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import messages from './messages';
import Button from '../button/index';
import css from './index.scss';

class FileUploader extends Component {
    constructor(props) {
        super(props);
        this.state = { uploadedFile: '', filename: '', disableUpload: true };
    }

    handleOnUploadChange = (e) => {
        const file = e.target.files[0];
        this.setState({ uploadedFile: file, filename: file.name, disableUpload: false });
    }

    handleOnUploadClick = () => {
        this.props.handleOnUploadClick(this.state.uploadedFile);
        this.uploadFile.value = '';
    }

    render() {
        this.uploadFile = (element) => {
            this.uploadFile = element;
        };
        return (
            <div>
                <div className={css.fileUpload}>
                    <div>{this.props.intl.formatMessage(messages.fileUpload)}</div>
                    <div className={css.uploadTextBox}> {this.state.filename} </div>
                    <div className={this.props.isUploading ? css.browseButtonWrapperDisabled : css.browseButtonWrapper}>
                        <input
                            accept=".xls,.xlsx"
                            className={css.browseButton}
                            id="file"
                            name="file"
                            onChange={this.handleOnUploadChange}
                            ref={this.uploadFile}
                            type="file" />
                        <label htmlFor="file">{this.props.intl.formatMessage(messages.browse)}</label></div>
                </div>
                <div><Button
                    containerClassName={css.uploadButton}
                    disabled={this.state.disableUpload}
                    handleOnClick={this.handleOnUploadClick}
                    label={this.props.intl.formatMessage(messages.upload)}
                    loading={this.props.isUploading}
                    loadingLabel={this.props.intl.formatMessage(messages.uploading)}
                /></div>
            </div>
        );
    }
}


FileUploader.propTypes = {
    handleOnUploadClick: PropTypes.func,
    isUploading: PropTypes.bool,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(FileUploader));



// WEBPACK FOOTER //
// ./app/components/file-uploader/index.js